import { i as o } from "./index869.mjs";
var t = o, s = String, e = TypeError, a = function(r) {
  if (t(r))
    return r;
  throw new e("Can't set " + s(r) + " as a prototype");
};
export {
  a
};
